import {Fragment, memo} from 'react'

import classNames from 'classnames/bind'

import Styles from './InsuranceDetailHeadLineBox.module.scss'

import type {보험종류} from '$constants/api-infos'

const cx = classNames.bind(Styles)

const 우리동네무료보험 = () => {
    return (
        <>
            주민등록 주소지를 기준으로
            <br />
            지자체에서 <em className={cx('emphasis')}>자동으로 가입해주는 무료 보험</em>
        </>
    )
}

const 종신보험 = () => {
    return (
        <>
            사망 이후 <em className={cx('emphasis')}>가족의 생계를 대비</em>하고
            <br />
            보장하기 위한 보험
        </>
    )
}

const 정기보험 = () => {
    return (
        <>
            <em className={cx('emphasis')}>사망을 대비하는 보험</em>이지만
            <br />
            보험기간이 상대적으로 짧은 보험
        </>
    )
}

const 질병건강보험 = () => {
    return (
        <>
            갑자기 병에 걸리거나 사고를 당해
            <br />
            <em className={cx('emphasis')}>몸이 아플 때를 대비</em>하기 위한 보험
        </>
    )
}

const 상해보험 = () => {
    return (
        <>
            우연한 사고로 인해
            <br />
            <em className={cx('emphasis')}>다쳤을 경우 치료비를 보장</em>하는 보험
        </>
    )
}

const 암보험 = () => {
    return (
        <>
            <em className={cx('emphasis')}>암에 걸렸을 때</em>
            <br />
            진단비, 입원비, 치료비 등을 보장하는 보험
        </>
    )
}

const 간병요양보험 = () => {
    return (
        <>
            <em className={cx('emphasis')}>질병이나 노화</em>로 인해
            <br />
            도움이 필요한 경우를 대비하기 위한 보험
        </>
    )
}

const 어린이보험 = () => {
    return (
        <>
            <em className={cx('emphasis')}>태아부터 30세까지 가입</em> 가능하며
            <br />
            사고나 질병 등의 위험을 대비하기 위한 보험
        </>
    )
}

const 치아보험 = () => {
    return (
        <>
            충치 치료와 같은
            <br />
            <em className={cx('emphasis')}>치과 치료비를 보장</em>하는 보험
        </>
    )
}

const 연금저축보험 = () => {
    return (
        <>
            연금 목적의 보험상품으로
            <br />
            <em className={cx('emphasis')}>연말정산 때 세액공제</em>를 받을 수 있는 보험
        </>
    )
}

const 연금보험 = () => {
    return (
        <>
            연금 목적의 보험상품으로
            <br />
            <em className={cx('emphasis')}>연금 수령할 때 비과세 혜택</em>을 받을 수 있는 보험
        </>
    )
}

const 저축보험 = () => {
    return (
        <>
            <em className={cx('emphasis')}>일반적인 저축 기능</em>과 더불어
            <br />
            위험을 대비한 보장도 받을 수 있는 보험
        </>
    )
}

const 교육보험 = () => {
    return (
        <>
            자녀의 입학금이나 학비와 같은
            <br />
            <em className={cx('emphasis')}>교육자금을 대비</em>하기 위한 보험
        </>
    )
}

const 운전자보험 = () => {
    return (
        <>
            <em className={cx('emphasis')}>자동차 운전 중 생긴 사고</em>로 인한
            <br />
            벌금 및 사고처리비용을 보장해주는 보험
        </>
    )
}

const 여행자보험 = () => {
    return (
        <>
            <em className={cx('emphasis')}>여행 중에 발생하는</em>
            <br />
            다양한 사고에 대비하기 위한 보험
        </>
    )
}

const 골프보험 = () => {
    return (
        <>
            <em className={cx('emphasis')}>골프를 즐기는 과정</em>에서 생기는
            <br />
            다양한 손해를 보장하는 보험
        </>
    )
}

const 실손의료보험 = () => {
    return (
        <>
            병원이나 약국에서 발생한
            <br />
            <em className={cx('emphasis')}>의료비를 보장</em>하는 기본적인 보험
        </>
    )
}

const 자동차보험 = () => {
    return (
        <>
            <em className={cx('emphasis')}>자동차를 소유하거나 운행</em>하는 사람이라면
            <br />
            필수적으로 가입해야하는 보험
        </>
    )
}

const 화재재물보험 = () => {
    return (
        <>
            가게나 주택에
            <br />
            <em className={cx('emphasis')}>화재 사고가 발생</em>했을 때를 대비하는 보험
        </>
    )
}

const 배상책임보험 = () => {
    return (
        <>
            나의 실수로 생긴
            <br />
            <em className={cx('emphasis')}>타인에 대한 손해배상책임</em>을 보장하는 보험
        </>
    )
}

const 보증신용보험 = () => {
    return (
        <>
            전세금 보증보험처럼
            <br />
            <em className={cx('emphasis')}>맡긴 돈으로 발생할 수 있는 손해</em>를 대비하는 보험
        </>
    )
}

const 펫보험 = () => {
    return (
        <>
            반려동물의
            <br />
            <em className={cx('emphasis')}>동물병원 치료비</em>를 보장하는 보험
        </>
    )
}

const 종합보장보험 = () => {
    return (
        <>
            질병이나 상해와 같은
            <br />
            <em className={cx('emphasis')}>건강과 관련 위험을 종합적으로 </em>대비하는 보험
        </>
    )
}

const 단기상해보험 = () => {
    return (
        <>
            우연한 사고로 인해
            <br />
            <em className={cx('emphasis')}>다쳤을 경우 치료비를 보장하는 보험기간이 짧은</em> 보험
        </>
    )
}

const 기타보험 = () => {
    return <>정의되지 않은 유형의 보험</>
}

const HeadLineBox: Record<보험종류, () => JSX.Element> = {
    우리동네무료보험,
    종신보험,
    정기보험,
    질병건강보험,
    상해보험,
    암보험,
    간병요양보험,
    어린이보험,
    치아보험,
    연금저축보험,
    연금보험,
    저축보험,
    교육보험,
    운전자보험,
    여행자보험,
    골프보험,
    실손의료보험,
    자동차보험,
    화재재물보험,
    배상책임보험,
    보증신용보험,
    펫보험,
    종합보장보험,
    단기상해보험,
    기타보험,
}

function InsuranceDetailHeadLineBox({type}: {type?: 보험종류}) {
    const HeadLineBoxComponent = type ? HeadLineBox[type] : Fragment

    return (
        <div className={cx('article')}>
            <p className={cx('text')}>
                <HeadLineBoxComponent />
            </p>
        </div>
    )
}

export default memo(InsuranceDetailHeadLineBox)
